<template>
  <div class="controls-wrap table-responsive">
    <!-- Integration Field -->
    <div class="jobs-controls m-3">
      <h6 class="d-flex align-items-center">
        Documents
        <button
          type="button"
          class="ml-auto btn btn-success text-nowrap d-none d-sm-block"
          @click="showModal = true"
        >
          Add Document
        </button>
      </h6>

      <CustomMainModal @close="onCloseDocumentsModal" v-show="showModal">
        <template v-slot:header>
          <h5>Add Document</h5>
        </template>

        <section v-if="showModal">
          <div class="row justify-content-center">
            <div class="col-md-11 mt-4">
              <Message v-show="errorMessage" class="mt-2" type="error-alert">
                <p slot="alert-message" class="mb-0">{{ errorMessage }}</p>
              </Message>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-md-11">
              <form ref="fileForm" key="fileForm">
                <div class="dropzone p-4">
                  <div class="dropzone-message file-drag-drop">
                    <p class="small drop-files">
                      Upload document here or click to browse for file.
                    </p>

                    <label
                      for="candidate-files"
                      class="btn btn-primary btn-sm file-upload-label mb-0"
                      >Browse</label
                    >

                    <input
                      type="file"
                      id="candidate-files"
                      ref="candidateDocumentsFiles"
                      name="candidateDocumentsFiles"
                      @input="handleCandidateDocumentsFileUpload"
                      class="file-upload-input"
                      accept=".doc,.docx,.pdf,.odt"
                      multiple
                    />

                    <ul class="list-group file-listing mt-3">
                      <FileToUpload
                        v-for="(file, index) in candidateDocumentsFiles"
                        :key="file.id"
                        :index="index"
                        :file="file"
                        @setPrimary="setPrimaryDocument($event)"
                        @deleteDoc="removeDocument($event)"
                      />
                      <!--  <li
                        v-for="(file, key) in candidateDocumentsFiles"
                        :key="key"
                        class="list-group-item d-flex align-items-center small"
                      >
                        <span class="mr-3">
                          <i
                            ref="primaryIcon"
                            :title="
                              itemId == key ? 'Select as primary CV' : 'Deselect as primary CV'
                            "
                            @click="setAsPrimary($event)"
                            :id="key"
                            :class="['fas fa-crown', itemId == key ? 'crown-active' : '']"
                          ></i>
                        </span>

                        <span class="mr-auto">{{ file.name }}</span>
                        <span class="badge badge-primary badge-pill ml-auto">{{
                          `${(file.size / 1024 / 1024).toFixed(2)} MB`
                        }}</span>
                        <span class="remove-container ml-4">
                          <span class="close" style="cursor: pointer" @click="removeFile(key)"
                            >&times;</span
                          >
                        </span>
                      </li> -->
                    </ul>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="row justify-content-center mb-5">
            <div class="col-md-5">
              <div class="text-center mt-3 d-flex">
                <button
                  @click="submitFiles"
                  :disabled="candidateDocumentsFiles.length <= 0"
                  class="btn btn-secondary btn-custom w-50 mr-4"
                >
                  Upload
                </button>
                <button class="btn btn-primary btn-custom w-50" @click="cancelUpload">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </section>
      </CustomMainModal>
    </div>
    <div class="content">
      <table
        v-show="getCandidateDocuments.length > 0"
        class="table table-striped custom-table table-responsive"
      >
        <thead class="bg-dark">
          <tr>
            <th nowrap scope="col" style="width: 1%; font-weight: 600">PRIMARY</th>
            <th nowrap scope="col" style="width: 45%; font-weight: 600">DOCUMENT NAME</th>
            <th nowrap scope="col" style="font-weight: 600">DATE</th>
            <th nowrap scope="col" style="width: 10%; font-weight: 600; text-align: center">
              ACTIONS
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="document in getCandidateDocuments" :key="document.id">
            <td align="center">
              <popper
                trigger="hover"
                :options="{
                  placement: 'right',
                  modifiers: { offset: { offset: '0,10px' } },
                }"
              >
                <div class="popper">
                  {{ !document.is_default ? 'Select as primary CV' : 'Deselect as primary CV' }}
                </div>
                <div slot="reference">
                  <i
                    ref="primaryIcon"
                    :id="document.id"
                    @click="setAsDefault"
                    class="fas fa-crown"
                    :class="[document.is_default ? 'crown-active' : '']"
                  ></i>
                </div>
              </popper>
            </td>
            <td id="document-name">
              <div class="d-flex">
                <i
                  @click="openDocPreview(document.id, document.name)"
                  :class="[`mr-3 fa`, document.icon]"
                  :style="`cursor: pointer; color: ${getIconColor(document.name)}; font-size: 22px`"
                ></i>

                <router-link to>
                  <span @click="openDocPreview(document.id, document.name)">{{
                    document.name
                  }}</span></router-link
                >
              </div>
            </td>
            <td id="documents" nowrap>
              <popper
                trigger="hover"
                :options="{
                  placement: 'left',
                  modifiers: { offset: { offset: '0,10px' } },
                }"
              >
                <div class="popper">
                  {{
                    document.created_at
                      | formatDate({
                        format: getUserProfile.format_date,
                        timezone: getUserProfile.timezone,
                        hasHourAndMinutes: true,
                      })
                  }}
                </div>
                <div slot="reference">
                  {{
                    document.created_at
                      | formatDate({
                        format: getUserProfile.format_date,
                        timezone: getUserProfile.timezone,
                        hasHourAndMinutes: false,
                      })
                  }}
                </div>
              </popper>
            </td>
            <td id="documents-actions">
              <div class="icon-wrapper d-flex justify-content-between" style="width: 100px">
                <svgHelper
                  @click.native="openDocPreview(document.id, document.name)"
                  class="mr-3"
                  name="view"
                />
                <svgHelper
                  @click.native="onDownloadDocument(document.id, document.name)"
                  class="mr-3 download-arrow"
                  name="download"
                />
                <a data-toggle="modal" href="#deleteModal" @click="setDeleteDocument(document)">
                  <svgHelper name="delete" />
                </a>
              </div>
              <!-- Delete Modal -->
              <div
                class="modal fade edit-modal"
                id="deleteModal"
                tabindex="-1"
                aria-labelledby="deleteModal"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-dialog-centered">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="editModal2Label">Delete File</h5>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>

                    <div class="modal-body text-center justify-content-center">
                      <p>Please confirm that you want to delete {{ documentToDelete.name }}</p>
                    </div>
                    <div class="modal-footer text-center justify-content-center">
                      <button
                        type="button"
                        class="btn btn-primary"
                        data-dismiss="modal"
                        @click="onDeleteDocument(documentToDelete.id)"
                      >
                        Delete
                      </button>

                      <button type="button" class="btn btn-secondary" data-dismiss="modal">
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- End Delete Modal -->
            </td>
          </tr>
        </tbody>
      </table>

      <ErrorList
        class="no-data-message"
        v-show="getCandidateDocuments.length == 0"
        name="noDocuments"
      />

      <Spinner :isLoading="isLoading" />

      <Spinner :isLoading="isCvLoading" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

/* import Pagination from '@/components/Navigations/Pagination'; */
import CustomMainModal from '@/components/Modals/CustomMainModal';
import Message from '../../AlertMessages/Message';
import ErrorList from '@/components/common/errorsList';
import FileToUpload from './CandidateItemFileToUpload';

/* import { selectDefaultDocument } from '../../../mixins/selectDefaultDocumentMixin'; */
import { errorService } from '../../../services/errorService';

import axios from 'axios';

// import moment from 'moment-timezone';

const MAX_FILE_SIZE = 20;

export default {
  components: { CustomMainModal, Message, ErrorList, FileToUpload },
  /*  mixins: [selectDefaultDocument], */
  data: () => ({
    isCvLoading: false,
    itemId: null,
    isLoading: false,
    showModal: false,
    isPrimary: false,
    files: [],
    file: '',
    candidateDocumentsFiles: [],
    errorMessage: '',
    isUploading: false,
    documentToDelete: '',
  }),
  methods: {
    ...mapActions([
      'retrieveCandidateDocument',
      'retrieveDocumentPreview',
      'retrieveCandidateById',
      'retrieveUserProfile',
      'setDefaultDocument',
      'deleteDocument',
    ]),
    onCloseDocumentsModal() {
      this.candidateDocumentsFiles = [];
      this.showModal = false;
    },
    getIconColor(fileName) {
      const re = /(?:\.([^.]+))?$/;
      if (re.exec(fileName)[1] === 'pdf') {
        return '#ff0000';
      } else if (re.exec(fileName)[1] === 'docx' || re.exec(fileName)[1] === 'doc') {
        return '#005a9e';
      } else {
        return '#a7a7a77';
      }
    },
    setDeleteDocument(doc) {
      this.documentToDelete = doc;
    },
    onDeleteDocument(id) {
      this.deleteDocument({ uuid: id })
        .then(() => {
          this.retrieveCandidateById({ uuid: this.$route.params.candidate_id });
        })
        .catch(error => {
          if (
            error.response &&
            error.response.status === 422 &&
            error.response.data &&
            error.response.data.internal_code === 6001
          ) {
            this.$toasted.error("A document that exists in a pipeline can't be deleted", {
              theme: 'bubble',
              icon: 'fa-check-circle',
              position: 'bottom-right',
              duration: 5000,
            });
          }
        });
    },
    setPrimaryDocument(index) {
      if (this.candidateDocumentsFiles[index].isPrimary) {
        this.candidateDocumentsFiles[index].isPrimary = false;
      } else {
        for (let i = 0; i < this.candidateDocumentsFiles.length; i++) {
          this.candidateDocumentsFiles[i].isPrimary = i === index;
        }
      }
    },
    removeDocument(index) {
      if (index > -1 && index < this.candidateDocumentsFiles.length) {
        this.candidateDocumentsFiles.splice(index, 1);
      }
    },
    setAsDefault(e) {
      this.isLoading = true;

      this.setDefaultDocument({ uuid: e.target.id })
        .then(() => {
          this.isLoading = false;
          this.retrieveCandidateById({ uuid: this.$route.params.candidate_id });
        })
        .catch(() => (this.isLoading = false));
    },
    handleCandidateDocumentsFileUpload() {
      const uploadedFiles = this.$refs['candidateDocumentsFiles'].files;
      for (let i = 0; i < uploadedFiles.length; i++) {
        const file = uploadedFiles[i];
        const fileSize = (file.size / 1024 / 1024).toFixed(2);

        if (fileSize > MAX_FILE_SIZE) {
          this.errorMessage = `The file size exceeds the limit of ${MAX_FILE_SIZE} MB.`;
          continue;
        }
        if (uploadedFiles.length === 1 && this.candidateDocumentsFiles.length === 0) {
          this.candidateDocumentsFiles.push({ file: file, isPrimary: true });
        } else if (uploadedFiles.length > 1 && this.candidateDocumentsFiles.length === 0) {
          if (i === 0) {
            this.candidateDocumentsFiles.push({ file: file, isPrimary: true });
          } else {
            this.candidateDocumentsFiles.push({ file: file, isPrimary: false });
          }
        } else {
          this.candidateDocumentsFiles.push({ file: file, isPrimary: false });
        }
      }
      this.$refs.candidateDocumentsFiles.value = '';
    },

    submitFiles() {
      this.isUploading = true;

      const formData = new FormData();
      for (let i = 0; i < this.candidateDocumentsFiles.length; i++) {
        const file = this.candidateDocumentsFiles[i].file;

        const fileSize = (file.size / 1024 / 1024).toFixed(2);

        if (fileSize > MAX_FILE_SIZE) {
          this.errorMessage = `The file size exceeds the limit of ${MAX_FILE_SIZE} MB.`;
        } else {
          formData.append(`file_${i}`, file);
          if ((this, this.candidateDocumentsFiles[i].isPrimary)) {
            formData.append(`primary_${i}`, true);
          }
        }
      }

      formData.append('files_count', this.candidateDocumentsFiles.length);
      formData.append('js_candidate_id', this.$route.params.candidate_id);

      if (this.candidateDocumentsFiles.length) {
        axios
          .post(`${process.env.VUE_APP_API_URL}/admin/candidatedocuments/upload`, formData, {
            headers: {
              Accept: 'application/json',
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
              'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: progressEvent => {
              this.uploadPercentage = parseInt(
                Math.round((progressEvent.loaded * 100) / progressEvent.total),
              );
            },
          })
          .then(() => {
            this.isUploading = false;
            this.uploadPercentage = 0;
            this.errorMessage = '';
            this.candidateDocumentsFiles = [];
            this.retrieveCandidateById({ uuid: this.$route.params.candidate_id });

            this.showModal = false;
          })
          .catch(err => {
            this.$toasted.error(`${err}`, {
              theme: 'bubble',
              icon: 'fa-check-circle',
              position: 'bottom-right',
              duration: 5000,
            });

            this.isUploading = false;
            this.uploadPercentage = 0;
          });
      }
    },
    closeModal() {
      this.errorMessage = '';
      this.candidateDocumentsFiles = [];
      this.showModal = false;
    },
    removeFile(key) {
      this.candidateDocumentsFiles.splice(key, 1);
    },
    cancelUpload() {
      this.candidateDocumentsFiles = [];
      this.showModal = false;
    },
    determineDragAndDropCapable() {
      const div = document.createElement('div');
      return (
        ('draggable' in div || ('ondragstart' in div && 'ondrop' in div)) &&
        'FormData' in window &&
        'FileReader' in window
      );
    },
    onDownloadDocument(docId, docTitle) {
      this.retrieveCandidateDocument({ uuid: docId, preview: 'false' })
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute('download', `${docTitle}`);
          document.body.appendChild(fileLink);

          fileLink.click();
        })
        .catch(err => {
          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
    openDocPreview(docId, name) {
      const fileExtension = name
        .split('.')
        .pop()
        .toLowerCase();
      const imageFileTypes = ['jpg', 'jpeg', 'png', 'heic'];
      if (imageFileTypes.includes(fileExtension)) {
        this.retrieveDocumentPreview({ uuid: docId, preview: 'true' })
          .then(response => {
            let mimeType;
            switch (fileExtension) {
              case 'png':
                mimeType = 'image/png';
                break;
              case 'heic':
                mimeType = 'image/heic';
                break;
              default:
                mimeType = 'image/jpeg';
            }

            const blob = new window.Blob([response.data], { type: mimeType });
            const fileURL = window.URL.createObjectURL(blob);

            // Open the image in a new tab
            const newWindow = window.open('', '_blank');
            newWindow.document.write(`
          <html>
            <head>
              <title>Image Preview</title>
            </head>
            <body style="margin:0;">
              <img src="${fileURL}" style="width:100%; height:100%; object-fit:contain;" />
            </body>
          </html>
        `);
            newWindow.document.close();
          })
          .catch(() => {
            this.isCvLoading = false;
          });
      } else {
        this.isCvLoading = true;
        this.retrieveDocumentPreview({ uuid: docId, preview: 'true' })
          .then(response => {
            this.isCvLoading = false;
            const blob = new window.Blob([response.data], { type: 'application/pdf' });

            const fileURL = window.URL.createObjectURL(blob);

            window.open(fileURL, '_blank').focus();
          })
          .catch(() => {
            this.isCvLoading = false;
          });
      }
    },
  },
  computed: {
    ...mapGetters(['getCandidateDocuments', 'getUserProfile']),
  },
  mounted() {
    this.dragAndDropCapable = this.determineDragAndDropCapable();
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/_mixins';

/* Default select doc icon */
@include select-default-document-icon-styles;
@include orange-scrollbar;

.controls-wrap {
  overflow: hidden;
  h6 {
    font-size: 18px;
    font-weight: 700;
    margin-block: 8px;
  }
}
.content {
  position: relative;
  height: 320px;
  overflow-y: auto;
}

.input-group {
  position: relative;
  i {
    position: absolute;
    pointer-events: none;
    top: 8px;
    right: 12px;
    z-index: 999;
    color: $color-table-location;
    font-size: 21px;
  }
  .form-control {
    border-radius: 0.25rem !important;
  }
}

.svg-icon:hover {
  cursor: pointer;
}

.icon-wrapper {
  svg {
    width: 16px;
    height: 18px;
  }
}

.controls-wrap .custom-table i {
  color: #a7a7a7;
  font-size: 16px;
}
</style>
